import axios from "axios";
import { aspNetUrl } from "../../axiosInstance";

export const getAllAdvertising = () => {
  return axios.get(`${aspNetUrl}Advertising`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const getAllPerCategoryId = (CategoryId) => {
  return axios.get(`${aspNetUrl}Advertising?CategoryId=${CategoryId}`, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};

export const Save = (data) => {
  return axios.post(`${aspNetUrl}Advertising`, data, {
    headers: {
      Authorization: `bearer ${localStorage.token}`,
      "Access-Control-Allow-Origin": "*",
    },
  });
};
